import { useState, useEffect, useCallback } from 'react';
import { Snackbar, Alert } from "@mui/material";
import { snackService } from 'services';

export function Snack() {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
    autoHideDuration: 3000,
    anchorOrigin: { vertical: "bottom", horizontal: "center" },
  });
  
  useEffect(() => snackService.subscribe(setSnack), []);
  
  const handleClose = useCallback(() => snackService.close(), []);
  
  return (
    <Snackbar
      open={snack.open}
      autoHideDuration={snack.autoHideDuration ?? undefined}
      onClose={handleClose}
      anchorOrigin={snack.anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={snack.severity}
        action={snack.action}
      >
        {snack.message}
      </Alert>
    </Snackbar>
  );
}